export const visit = (vm, at) => {
vm(require("reporting-enablement/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("reporting-ui-components/lang/en.lyaml"));
vm(require("reporting-visualizations/lang/en.lyaml"));
vm(require("reporting-data/lang/en.lyaml"));
vm(require("reporting-action-components/lang/en.lyaml"));
vm(require("ExportDialog/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
at({ "en": { "reportCard": { "error": { "message": "Please refresh the page and try again.", "title": "There was a problem loading this report.", "custom": { "message": "Check that this report's ID belongs to single object report. ", "knowledgeBase": "Learn more", "title": "There was a problem loading this report." }, "permissions": { "message": "Ask the owner of this report to update your access.", "title": "You don't have permission to view this report." } } } } });
};